import { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import {
  Container,
  Header,
  Form,
  Message,
  Button,
  Divider
} from "semantic-ui-react";
import { updateProfile, changePassword } from "../features/user/userSlice";

const Profile = (props) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [screenName, setScreenName] = useState(user.screenName);
  const [usernameMessage, setUsernameMessage] = useState(null);
  const [savingUsername, setSavingUsername] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState(null);
  const [savingPassword, setSavingPassword] = useState(false);

  const handleUsernameSubmit = async (e) => {
    e.preventDefault();
    setUsernameMessage(null);
    if (!screenName.trim()) {
      setUsernameMessage({ type: "negative", text: "Username is required" });
      return;
    }
    setSavingUsername(true);
    const result = await dispatch(updateProfile({ userId: user.userId, screenName: screenName.trim() })).unwrap();
    setSavingUsername(false);
    if (result.success) {
      setUsernameMessage({ type: "positive", text: "Username updated." });
    } else {
      setUsernameMessage({ type: "negative", text: result.message || "Failed to update username." });
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordMessage(null);
    if (!newPassword) {
      setPasswordMessage({ type: "negative", text: "New password is required" });
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordMessage({ type: "negative", text: "The new passwords did not match" });
      return;
    }
    setSavingPassword(true);
    const result = await dispatch(changePassword({ userId: user.userId, currentPassword, newPassword })).unwrap();
    setSavingPassword(false);
    if (result.success) {
      setPasswordMessage({ type: "positive", text: "Password updated." });
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } else {
      setPasswordMessage({ type: "negative", text: result.message || "Failed to update password." });
    }
  };

  return (
    <Container text>
      <Header as="h1">My Account</Header>

      <Header as="h3">Username</Header>
      <Form onSubmit={handleUsernameSubmit}>
        <Form.Input
          label="Username"
          value={screenName}
          onChange={(e) => setScreenName(e.target.value)}
        />
        <Button primary loading={savingUsername} type="submit">Save Username</Button>
      </Form>
      {usernameMessage && (
        <Message color={usernameMessage.type === "positive" ? "green" : "red"} style={{ marginTop: "1em" }}>
          {usernameMessage.text}
        </Message>
      )}

      <Divider />

      <Header as="h3">Change Password</Header>
      <Form onSubmit={handlePasswordSubmit}>
        <Form.Input
          label="Current Password"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <Form.Input
          label="New Password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <Form.Input
          label="Confirm New Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button primary loading={savingPassword} type="submit">Save Password</Button>
      </Form>
      {passwordMessage && (
        <Message color={passwordMessage.type === "positive" ? "green" : "red"} style={{ marginTop: "1em" }}>
          {passwordMessage.text}
        </Message>
      )}
    </Container>
  );
};

export default Profile;
